import { Box, type BoxProps, Skeleton } from '@mantine/core'
import clsx from 'clsx'

import styles from './styles.module.css'

export type LoadingProps = BoxProps & {
  items?: number
}

export function Loading({ items = 5, ...props }: LoadingProps) {
  const classes = clsx(styles.loading, props.className)

  return (
    <Box
      {...props}
      className={classes}
      style={{
        gridTemplateColumns: `repeat(${items}, 1fr)`,
        fontWeight: 'bold',
      }}
    >
      {Array.from(Array(items).keys()).map((item) => (
        <Skeleton h={380} key={item} />
      ))}
    </Box>
  )
}
